import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsInputClicked = ({
  blockId,
  blockVariationId,
  settingId,
  tabId,
  elementType,
  controlId,
}) => {
  if (!blockId || !controlId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_INPUT_CLICKED, {
    blockId,
    blockVariationId,
    settingId,
    tabId,
    elementId: elementType,
    inputId: controlId,
  });
};

export default trackElementSettingsInputClicked;
